import React, {useEffect, useState} from 'react';

const calculateGridHeight = (
    filtersRef: React.RefObject<HTMLElement | null>,
    headerSelector = 'header',
    padding = 64,
    bottomOffset = 115,
    minHeight = 200
): number => {
    const headerHeight = document.querySelector(headerSelector)?.clientHeight || 0;
    const filtersHeight = filtersRef?.current?.clientHeight || 0;
    const total = window.innerHeight - headerHeight - filtersHeight - padding - bottomOffset;
    return Math.max(minHeight, total);
};

export const useGridHeight = (
    filtersRef: React.RefObject<HTMLElement | null>,
    headerSelector = 'header',
    padding = 64,
    bottomOffset = 115,
    minHeight = 200
): number => {
    const [height, setHeight] = useState<number>(() =>
        calculateGridHeight(filtersRef, headerSelector, padding, bottomOffset, minHeight)
    );


    useEffect(() => {
        const update = () =>
            setHeight(calculateGridHeight(filtersRef, headerSelector, padding, bottomOffset, minHeight));
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, [filtersRef, headerSelector, padding, bottomOffset, minHeight]);

    return height;
};

export const createFilterChangeHandler = <T extends { page?: number }>(
    setRequest: React.Dispatch<React.SetStateAction<T>>
) => {
    return (key: keyof T) => (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> | any
    ) => {
        const target = event?.target as { value?: any; checked?: boolean; type?: string } | undefined;
        const value = target?.type === 'checkbox' ? target?.checked : target?.value;
        setRequest((prev) => ({...prev, [key]: value, page: 0} as T));
    };
};

